import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import Button from '../../../../../components/Button';
import { ModalFooterContainer } from '../../../../../components/Modal';

const Container = styled.div`
  & > p {
    margin-bottom: 20px;
  }
`;

interface Props {
  serverName?: string;
  isServerEnabled?: boolean;
  isProcessing: boolean;
  cancelButtonHandler: () => void;
  updateButtonHandler: () => void;
}

export default function UpdateModalContent(props: Props) {
  const { serverName, isServerEnabled, isProcessing, cancelButtonHandler, updateButtonHandler } = props;

  return (
    <Container>
      <p>Are you sure you want to <b>{isServerEnabled ? 'disable' : 'enable'}</b> {serverName}?</p>

      <ModalFooterContainer>
        <Button
          className="secondary"
          text="Cancel"
          style={{ width: "100%" }}
          onClick={cancelButtonHandler}
        />

        <Button
          text={isServerEnabled ? 'Disable' : 'Enable'}
          className={isServerEnabled ? 'danger' : ''}
          style={{ width: "100%" }}
          loading={isProcessing}
          onClick={updateButtonHandler}
        />
      </ModalFooterContainer>
    </Container>
  );
}